import React from "react";

const LocationIcon = ({ className, size = 20 }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99967 1.875C5.97884 1.875 2.70801 5.14583 2.70801 9.16667C2.70801 13.4317 6.62217 16.0166 9.21217 17.7275L9.65301 18.02C9.75801 18.09 9.87884 18.125 9.99967 18.125C10.1205 18.125 10.2413 18.09 10.3463 18.02L10.7872 17.7275C13.3772 16.0166 17.2913 13.4317 17.2913 9.16667C17.2913 5.14583 14.0205 1.875 9.99967 1.875ZM10.0988 16.6842L9.99967 16.7501L9.9005 16.6842C7.39217 15.0275 3.95801 12.7592 3.95801 9.16667C3.95801 5.835 6.66801 3.125 9.99967 3.125C13.3313 3.125 16.0413 5.835 16.0413 9.16667C16.0413 12.7592 12.6063 15.0283 10.0988 16.6842ZM9.99967 6.45833C8.50634 6.45833 7.29134 7.67333 7.29134 9.16667C7.29134 10.66 8.50634 11.875 9.99967 11.875C11.493 11.875 12.708 10.66 12.708 9.16667C12.708 7.67333 11.493 6.45833 9.99967 6.45833ZM9.99967 10.625C9.19551 10.625 8.54134 9.97083 8.54134 9.16667C8.54134 8.3625 9.19551 7.70833 9.99967 7.70833C10.8038 7.70833 11.458 8.3625 11.458 9.16667C11.458 9.97083 10.8038 10.625 9.99967 10.625Z"
      fill="#7A7A7A"
    />
  </svg>
);

export default LocationIcon;
